import {
  type EdgeId,
  isDeviceType,
  isPathLookupNodeData,
} from '@ipfabric/utils';
import type { GraphData } from 'components/Graph/model/GraphData';

export const hasPacketSiblingPathLookupNode = (
  graphData: GraphData,
  siblingType: 'source' | 'target',
  edgeId: EdgeId,
): boolean => {
  const edgeData = graphData.edges[edgeId];
  if (edgeData === undefined) {
    return false;
  }
  const nodeData = graphData.nodes[edgeData[siblingType]];
  return (
    nodeData !== undefined &&
    isPathLookupNodeData(nodeData) &&
    isDeviceType(nodeData.type)
  );
};
